import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddIntubationToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../intubation/store/intubation.actions'
import { addIntubationItem } from '../../timeline/store/timeline.actions'
import { IntubationConstants } from '../../intubation/store/intubation.constants'

export function* saveIntubationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addIntubationToTimeline } = quickActionsObject
  if (addIntubationToTimeline) {
    yield put(addIntubationItem())
    yield put(setAddIntubationToTimeline(false))
    yield put(resetState())
  }
}

export function* saveIntubationQuickActionTimeLineRowSaga() {
  yield takeLatest([IntubationConstants.SET_ADD_TO_TIMELINE], saveIntubationQuickActionTimeLineRow)
}
